import { HttpStatusCode } from "axios";
import { IResultMessage, ResultMessage } from "./resultMessage";
import { createInstance } from "./responseUtility";


export interface IActionResponse {
    operationStatusCode?: HttpStatusCode;
    errorMessages?: string[] | null;
    warningMessages?: string[] | null;
    infoMessages?: string[] | null;
    successMessages?: string[] | null;
    messages?: IResultMessage[] | null;
    isSuccess?: boolean;
    isCancelled?: boolean;
}

export interface IActionResult<T> extends IActionResponse {
    result: T;
}

export class ActionResponse implements IActionResponse {
    operationStatusCode?: HttpStatusCode;
    errorMessages?: string[] | null;
    warningMessages?: string[] | null;
    infoMessages?: string[] | null;
    successMessages?: string[] | null;
    readonly messages?: ResultMessage[] | null;
    readonly isSuccess?: boolean;
    readonly isCancelled?: boolean;

    constructor(data?: ActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(item as any).toJSON ? new ResultMessage(item) : item as ResultMessage;
                }
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.operationStatusCode = _data["operationStatusCode"] !== undefined ? _data["operationStatusCode"] : null as any;
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            else {
                this.errorMessages = null as any;
            }
            if (Array.isArray(_data["warningMessages"])) {
                this.warningMessages = [] as any;
                for (let item of _data["warningMessages"])
                    this.warningMessages!.push(item);
            }
            else {
                this.warningMessages = null as any;
            }
            if (Array.isArray(_data["infoMessages"])) {
                this.infoMessages = [] as any;
                for (let item of _data["infoMessages"])
                    this.infoMessages!.push(item);
            }
            else {
                this.infoMessages = null as any;
            }
            if (Array.isArray(_data["successMessages"])) {
                this.successMessages = [] as any;
                for (let item of _data["successMessages"])
                    this.successMessages!.push(item);
            }
            else {
                this.successMessages = null as any;
            }
            if (Array.isArray(_data["messages"])) {
                (this as any).messages = [] as any;
                for (let item of _data["messages"])
                    (this as any).messages!.push(ResultMessage.fromJS(item, _mappings));
            }
            else {
                (this as any).messages = null as any;
            }
            (this as any).isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : null as any;
        }
    }

    static fromJS(data: any, _mappings?: any): ActionResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActionResponse>(data, _mappings, ActionResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operationStatusCode"] = this.operationStatusCode !== undefined ? this.operationStatusCode : null as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.warningMessages)) {
            data["warningMessages"] = [];
            for (let item of this.warningMessages)
                data["warningMessages"].push(item);
        }
        if (Array.isArray(this.infoMessages)) {
            data["infoMessages"] = [];
            for (let item of this.infoMessages)
                data["infoMessages"].push(item);
        }
        if (Array.isArray(this.successMessages)) {
            data["successMessages"] = [];
            for (let item of this.successMessages)
                data["successMessages"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        return data;
    }

    clone(): ActionResponse {
        const json = this.toJSON();
        let result = new ActionResult();
        result.init(json);
        return result;
    }
}

export class ActionResult<T> extends ActionResponse implements IActionResult<T> {
    result: T;

    constructor(data?: ActionResult<T>) {
        super();

        this.result = data?.result as T;
    }


    static fromJS<T>(data: any, _mappings?: any): ActionResult<T> | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActionResult<T>>(data, _mappings, ActionResult<T>);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        //data["result"] = this.result ? this.result.toJSON() : null as any;
        data["operationStatusCode"] = this.operationStatusCode !== undefined ? this.operationStatusCode : null as any;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.warningMessages)) {
            data["warningMessages"] = [];
            for (let item of this.warningMessages)
                data["warningMessages"].push(item);
        }
        if (Array.isArray(this.infoMessages)) {
            data["infoMessages"] = [];
            for (let item of this.infoMessages)
                data["infoMessages"].push(item);
        }
        if (Array.isArray(this.successMessages)) {
            data["successMessages"] = [];
            for (let item of this.successMessages)
                data["successMessages"].push(item);
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null as any;
        return data;
    }

    clone<T>(): ActionResult<T> {
        const json = this.toJSON();
        let result = new ActionResult<T>();
        result.init(json);
        return result;
    }

}